// extracted by mini-css-extract-plugin
module.exports = {"star":"styles_star__2Xagk","pop":"styles_pop__1_jRn","rating-pop":"styles_rating-pop__Z432y","rating-ring":"styles_rating-ring__dRvZ6"};